import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Tabs, Tab, Button, Accordion, AccordionSummary, AccordionDetails, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { connect } from 'react-redux';
import { RESET_FAQ_WINDOW } from './FaqActions';
import { openReportProblem } from '../ReportProblem/ReportProblemButton';
import { replaceURLs } from '__common/utils/helpers';
import 'app/components/FaqComponent/faq.scss';

const FrequentlyAskedQuestions = ({ faq, dispatch }) => {
  const [openToggleIndex, setOpenToggleIndex] = useState(null);
  const [activeTabIndex, setActiveTabIndex] = useState(0);

  const cancel = () => {
    dispatch(RESET_FAQ_WINDOW());
    setOpenToggleIndex(null);
    setActiveTabIndex(0);
  };

  const handleToggle = (index) => {
    setOpenToggleIndex(prevIndex => (prevIndex === index ? null : index));
  };

  const { open, faqData } = faq;

  if (!faqData) return null;

  const categoryKeys = Object.keys(faqData);

  return (
    <Dialog
      open={open}
      onClose={cancel}
      maxWidth="md"
      fullWidth
      aria-labelledby="faq-dialog-title"
      PaperProps={{
        className: "custom-modal faq-dialog"
      }}
    >
      <DialogTitle id="faq-dialog-title" className="titlefont">
        <div className="page-title">FREQUENTLY ASKED QUESTIONS</div>
      </DialogTitle>

      <DialogContent sx={{ padding: '10px', paddingLeft: '10px' }}>
        <div className="faq-body">
          <Tabs
            value={activeTabIndex}
            onChange={(_, newIndex) => {
              setActiveTabIndex(newIndex);
              setOpenToggleIndex(null); // Reset accordion on tab switch
            }}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="FAQ Category Tabs"
          >
            {categoryKeys.map((category, index) => (
              <Tab key={index} label={category} />
            ))}
          </Tabs>

          <div className="tab-content">
            {categoryKeys.map((category, categoryIndex) => (
              activeTabIndex === categoryIndex && (
                <div key={categoryIndex}>
                  {faqData[category].map((entry, entryIndex) => {
                    const toggleIndex = `${categoryIndex}-${entryIndex}`;

                    return (
                      <Accordion 
                        key={entryIndex}
                        expanded={openToggleIndex === toggleIndex}
                        onChange={() => handleToggle(toggleIndex)}
                        sx={{ 
                          marginBottom: 1,
                          '&:before': { display: 'none' },
                          boxShadow: 'none',
                          border: '1px solid #e5e5e5',
                          borderRadius: '4px !important'
                        }}
                      >
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls={`panel-${toggleIndex}-content`}
                          id={`panel-${toggleIndex}-header`}
                          sx={{
                            '& .MuiAccordionSummary-content': {
                              margin: '12px 0',
                            },
                            '&:hover': {
                              backgroundColor: 'rgba(18, 121, 225, 0.04)',
                            }
                          }}
                        >
                          <Typography 
                            className="faq-question"
                            variant="h6" 
                            sx={{ 
                              fontSize: '0.9rem',
                              fontWeight: 500,
                              fontFamily: 'PT Sans'
                            }}
                          >
                            {entry.Question
                              ? entry.Question.charAt(0).toUpperCase() + entry.Question.slice(1).toLowerCase()
                              : entry.Question}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails
                          sx={{
                            padding: '16px 24px',
                            borderTop: '1px solid #e5e5e5'
                          }}
                        >
                          <Typography 
                            className="faq-answer"
                            component="div"
                            sx={{
                              fontSize: '0.95rem',
                              fontFamily: 'PT Sans',
                              fontWeight: 400,
                              color: '#4d5974',
                              lineHeight: 1.6
                            }}
                          >
                            {entry.Answer
                              .split(/\. (?=(?:www|https?|http):\/\/|\S+)/)
                              .map((sentence, i) => (
                                <div key={i} dangerouslySetInnerHTML={{ __html: replaceURLs(sentence) }} />
                              ))}
                          </Typography>
                        </AccordionDetails>
                      </Accordion>
                    );
                  })}
                </div>
              )
            ))}
          </div>
        </div>
      </DialogContent>

      <DialogActions className="footer">
        <Button
          className="footer querybutton"
          onClick={() => {
            openReportProblem();
            cancel();
          }}
        >
          Got Something To Ask ?
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const mapStateToProps = (state) => ({
  faq: state.faq,
  user: state.user,
});

export default connect(mapStateToProps)(FrequentlyAskedQuestions);
